import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import isEmpty from 'lodash/isEmpty';
import uniqBy from 'lodash/uniqBy';
import flatten from 'lodash/flatten';
import { store } from "../../index";
import Menu from '@/store/helpers/menu';
import { makeQuestionScreen, addSubmitQuestion } from "./_utils";
import { passesIndicatorRule } from '@/store/helpers/rules';
import { FIB } from '@/config/constants';
var QUESTION_TYPE = FIB.QUESTION_TYPE,
    MENU_INSIGHT_MODE = FIB.MENU_INSIGHT_MODE;
/*
 * # Required menu data calls on a case by case basis for FIB-4093:
 * The enumerated behaviours in FIB-4093 line up with the following Menu Insight question modes:
 * (the mode is given by identifyMode(question))
 *
 * NB - The behaviours below reference those mentioned in the ticket, so check there for deets
 *
 * |               Mode               | Behaviours |
 * |----------------------------------|------------|
 * |      MENU_INSIGHT_MODE.TYPE      |   1a, 1b   |
 * |  MENU_INSIGHT_MODE.FAMILY_GROUP  |   2a, 2b   |
 * |  MENU_INSIGHT_MODE.MAJOR_GROUP   |   3a, 3b   |
 *
 * Use the Menu helper (included above, but you'll likely need it on the components), which pulls the required data from the appropriate place - either the store of the api directly depending on the device configuration.
 *
 * I've laid out the args per use case for the required calls -- I think this is where a lot of confusion comes from, let me know if you need to diverge from what's laid out!
 *
 * ## MENU_INSIGHT_MODE.TYPE (1a, 1b):
 *
 * For the list on the /questions page:
 *   Menu.getFamilyGroups({ type: question.menuType }):
 *     - This is pre-ordered by weight and name, which is the standard ordering. Not paginated, as there's relatively few.
 *
 * For the modal:
 *   Menu.getMajorGroups({ type: question.menuType, familyGroupRef: selectedFamilyGroupRef }):
 *     - This is for the pills at the top of the modal of major groups for a selected given family group. // NOTE - THIS ISN'T RETURNING THE PRODUCTS
 *     - Again, this is pre-sorted in the correct order
 *     - Not paginated, as there's relatively few.
 *
 *   // for text search
 *   Menu.getProducts({ page: scrollBased, type: question.menuType, familyGroupRef: filteredFamilyGroupRef, majorGroupRef: filteredMajorGroupRef, text: textFilterIfRequired }):
 *     - Filtering by text already knows which fields to search on. (major group AND product name)
 *     - filteredMajorGroupRef should be provided if the guest has clicked on a pill at the top
 *     - Pagination will have to occur as the user scrolls, the page size being determined by the api. There's way too many products to pull them all down.
 *     - The products returned will be ordered by (major group and name), which allows for the list grouping as shown in the designs.
 *
 * ## MENU_INSIGHT_MODE.FAMILY_GROUP (2a, 2b):
 *
 * For the list on the /questions page:
 *   Menu.getMajorGroups({ familyGroupRef: question.menuFamilyGroupRef }):
 *     - These are the major groups to be rendered for the family group provided by the question
 *
 * For the modal:
 *   Menu.getProducts({ page: scrollBased, familyGroupRef: question.menuFamilyGroupRef, majorGroupRef: filteredMajorGroupRef, text: textFilterIfRequired })
 *     - This doesn't need to be grouped by major group in this case as you've picked a major group to get here, so no point in showing the groups.
 *     - Again, necessarily scroll based pagination
 *
 * ## MENU_INSIGHT_MODE.MAJOR_GROUP (3a, 3b):
 *
 * For the list on the /questions page:
 *   Menu.getProducts({ page: scrollBased, majorGroupRef: question.menuMajorGroupRef })
 *       - No text searching required in this case.
 */

/**
 * Determines the mode of the Menu Insight question
 *
 * @param {Object} question
 *
 * @returns {Number}
 */

function identifyMode(question) {
  if (question.menuType) {
    return MENU_INSIGHT_MODE.TYPE;
  } else if (question.menuFamilyGroupRef) {
    return MENU_INSIGHT_MODE.FAMILY_GROUP;
  } else if (question.menuMajorGroupRef) {
    return MENU_INSIGHT_MODE.MAJOR_GROUP;
  }
}
/**
 * Map Menu Insight ratings to a more usable form for the app
 *
 * @param {Object} question
 *
 * @returns {Array}
 */


function parseRatings(question) {
  var ratings = cloneDeep(question.aspect.ratings);
  return ratings.map(function (r) {
    // Parse reasonMode:
    //   - 0 = Don't prompt with reasons;
    //   - 1 = Prompt with reasons only related to the selected rating;
    //   - 2 = Prompt with reasons related to the selected rating and the opposing rating (e.g. both Liked and Disliked reasons)
    var reasonSections = []; // Ensure the reasons matching the current aspectRatingId come first.
    // Find the opposite and same ratings, if they exist, where applicable, and push.

    var same = cloneDeep(ratings.find(function (o) {
      return o.aspectRatingId === r.aspectRatingId;
    }));
    same.showIf = {
      aspectRatingId: r.aspectRatingId
    };

    if (r.reasonMode === 0) {
      same.showIf.hide = true;
      reasonSections.push(same);
    } else if (r.reasonMode === 1) {
      reasonSections.push(same);
    } else if (r.reasonMode === 2) {
      var opposite = cloneDeep(ratings.find(function (o) {
        return o.oppositeId === r.aspectRatingId;
      }));
      opposite.showIf = {
        oppositeId: r.aspectRatingId
      };
      reasonSections.push(same);
      reasonSections.push(opposite);
    } // With reference to https://projects.invisionapp.com/share/3UVMGS14MRP#/screens/401223184, this is what we're returning here:


    return {
      // :(  :|  :)
      aspectRatingId: r.aspectRatingId,
      title: r.title,
      // oppositeId: r.oppositeId,
      // Each array element (r) represents a section like this:
      //     {r.title}                      ~~~~~~~~>            What was good?
      //     v-for="reason in r.reasons"    ~~~~~~~~>    | Freshness | Portion | Taste |
      //      (reason.text, reason.id)
      reasonSections: reasonSections
    };
  });
}

var type = QUESTION_TYPE.QUESTION_TYPE_MENU_INSIGHT;
export default {
  type: type,
  requiresTransaction: false,

  /**
   * Determines if a Menu Insight question should be added to the selection purely based on counts.
   */
  selectBasedOnCounts: function () {
    var _selectBasedOnCounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var survey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              survey = context.survey;

              if (!(context.selection.countByType(type) >= survey.menuInsight.maximum)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              return _context.abrupt("return", true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function selectBasedOnCounts(_x) {
      return _selectBasedOnCounts.apply(this, arguments);
    }

    return selectBasedOnCounts;
  }(),

  /**
   * Determines if a Menu Insight question should be added to the selection, ignoring counts.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var question, survey, filter;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              question = context.question, survey = context.survey; // Apply the indicator rule

              if (passesIndicatorRule(survey.menuInsight.indicatorRule)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", false);

            case 3:
              // Now check if any products would be shown on the Menu Insight question
              // (we put this condition last as it could result in an API call, which we'd prefer not to do, but have to here)
              // Perform the relevant filtering for the MenuInsight question, filtering out any falsy values for provided filters.
              filter = pickBy({
                type: question.menuType,
                familyGroupRef: question.menuFamilyGroupRef,
                majorGroupRef: question.menuMajorGroupRef
              }, identity);

              if (!store.getters['checkIn/hasTransaction']) {
                _context2.next = 8;
                break;
              }

              // If we have a transaction, the Menu Insight question will be shown filtered to the products ordered.
              //   We want to ensure in that case that we have at least one transaction product available when filtered
              // by the question filters.
              filter.transactionProductRefs = store.getters['checkIn/transactionProducts']().map(function (m) {
                return m.menuItemObjectNumber;
              }); // If there are no products - there's nothing to ask the guest about, so we won't ask
              // the question, and we don't need to make an API call to know that.

              if (filter.transactionProductRefs.length) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", false);

            case 8:
              _context2.t0 = !store.getters['config/isApp'];

              if (!_context2.t0) {
                _context2.next = 13;
                break;
              }

              _context2.next = 12;
              return Menu.productsExist(filter);

            case 12:
              _context2.t0 = !_context2.sent;

            case 13:
              if (!_context2.t0) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", false);

            case 15:
              _context2.t1 = !store.getters['checkIn/hasTransaction'] && identifyMode(question) === MENU_INSIGHT_MODE.TYPE && !store.getters['config/isApp'];

              if (!_context2.t1) {
                _context2.next = 20;
                break;
              }

              _context2.next = 19;
              return Menu.familyGroupsExist({
                type: question.menuType
              });

            case 19:
              _context2.t1 = !_context2.sent;

            case 20:
              if (!_context2.t1) {
                _context2.next = 22;
                break;
              }

              return _context2.abrupt("return", false);

            case 22:
              return _context2.abrupt("return", true);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function select(_x2) {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a Menu Insight Screen
   *
   * @param {Object} context (Required) The context in which to render
   * @param {Object} context.question (Required) the question to render
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
      var question, section;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              question = context.question, section = context.section;
              question.mode = identifyMode(question);
              question.ratings = parseRatings(question);
              question._meta = {
                section: section
              }; // question.followUpQuestion // indicates if the 'second page' consisting of reasons(=tags) should be shown
              // if follow up question true, comments always present, but need to look for reasons for showing reasons or not

              return _context3.abrupt("return", makeQuestionScreen(context, [{
                id: 'question' + question.id,
                type: 'fib-menu-insight-question',
                required: question.required,
                label: '',
                props: {
                  question: question
                }
              }], question, {
                title: question.text
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function render(_x3) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var _response$answers, _response$answers$;

    var question = context.question,
        response = context.response; // Individual product ratings are here - if there's nothing there, we're done!

    var ratings = (_response$answers = response.answers) === null || _response$answers === void 0 ? void 0 : (_response$answers$ = _response$answers[0]) === null || _response$answers$ === void 0 ? void 0 : _response$answers$.value;

    if (isEmpty(ratings)) {
      return null;
    } // Validate ratings


    ratings = ratings.filter(function (p) {
      return p.ref && p.aspectRatingId;
    }); // Deduplicate ratings for the same product

    ratings = uniqBy(ratings, 'ref');

    function prepRatingsForSubmission(question, ratings) {
      // prepare ratings for submission
      var prepped = cloneDeep(ratings); // Remove unrelated tags

      return prepped.map(function (rating) {
        // get rating details from question
        var details = question.ratings.find(function (r) {
          return r.aspectRatingId === rating.aspectRatingId;
        }); // remove tags not found in reason sections associated with this rating

        var acceptedTags = flatten(cloneDeep(details).reasonSections.map(function (s) {
          return _toConsumableArray(s.reasons.map(function (rsn) {
            return rsn.id;
          }));
        }));
        rating.tags = rating.tags.filter(function (t) {
          return acceptedTags.indexOf(t) !== -1;
        });
        return rating;
      });
    }

    return {
      ratings: ratings,
      prepped: prepRatingsForSubmission(question, ratings),
      mutateSubmit: function mutateSubmit(submit) {
        // Generate the product ratings to be submitted.
        var _iterator = _createForOfIteratorHelper(this.prepped),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var rating = _step.value;
            addSubmitQuestion(submit, response, {
              choices: [rating.ref],
              extra: {
                menuInsight: {
                  aspectRatingId: rating.aspectRatingId,
                  otherReason: rating.comment || null,
                  reasons: rating.tags || []
                }
              }
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };
  }
};